import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import io from 'socket.io-client';
import { getToken } from '@/utils/auth';

// 使用ElementUI
Vue.use(ElementUI, { size: 'medium' });

// 配置WebSocket
const socket = io(
  '/',
  {
    autoConnect: false,
  }
);

// 将socket挂载到Vue原型上
Vue.prototype.$socket = socket;

// 连接WebSocket
socket.on('connect', () => {
  console.log('WebSocket连接成功');
});

// 监听新的寻盘信息
socket.on('new_inquiry', (data) => {
  store.dispatch('updateNotification', { type: 'inquiry', count: data.count });
});

// 监听新的测样申请
socket.on('new_sample', (data) => {
  store.dispatch('updateNotification', { type: 'sample', count: data.count });
});

// 监听新的访客记录
socket.on('new_visitor', (data) => {
  store.dispatch('updateNotification', { type: 'visitor', count: data.count });
});

// 错误处理
socket.on('error', (error) => {
  console.error('WebSocket错误:', error);
});

// 断开连接处理
socket.on('disconnect', (reason) => {
  console.log('WebSocket断开连接:', reason);
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

// 登录成功后连接WebSocket
if (getToken()) {
  socket.connect();
}
